import axios from 'axios';
import { useCallback } from 'react';

import type { Response } from 'state/remote/types';

import type { Signup } from 'state/__generated__/tadaahAPI';
import { useApiSignupCreate } from 'state/__generated__/tadaahAPI';

const options: {
  label: string;
  value:
    | 'viavia'
    | 'facebook'
    | 'instagram'
    | 'linkedin'
    | 'indeed'
    | 'jobbird'
    | 'kinderopvangtotaal'
    | 'google_search'
    | 'google_ad';
}[] = [
  { label: 'Via kennissen/vrienden', value: 'viavia' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'Indeed', value: 'indeed' },
  { label: 'Jobbird', value: 'jobbird' },
  { label: 'Kinderopvang Totaal', value: 'kinderopvangtotaal' },
  { label: 'Google Zoekopdracht', value: 'google_search' },
  { label: 'Google Advertentie', value: 'google_ad' },
];

type UseFreelancerSignUpHandler = {
  signUp: (values: Signup) => Promise<Response>;
  isLoading: boolean;
  initialValues: Signup;
  options: typeof options;
  error: Error | null;
};

const useFreelancerSignUp = (): UseFreelancerSignUpHandler => {
  const { mutateAsync, isLoading, error } = useApiSignupCreate<Error>({
    mutation: {
      mutationKey: 'freelancer-signup',
    },
  });

  const signUp = useCallback(
    async (values: Signup): Promise<Response> => {
      try {
        const { data } = await mutateAsync({
          data: values,
        });
        return data as unknown as Response;
      } catch (err) {
        if (axios.isAxiosError(err)) {
          return {
            errors: err.response?.data,
            success: false,
          };
        }
        return { success: false };
      }
    },
    [mutateAsync],
  );

  const initialValues = {
    acquainted: 'viavia',
    email: '',
    first_name: '',
    last_name: '',
    password1: '',
    password2: '',
    username: '',
  } as Signup;

  return { error, initialValues, isLoading, options, signUp };
};

export default useFreelancerSignUp;
